class ThemeLocalStorage {
  constructor() {
    this.SetTheme = this.SetTheme.bind(this);
  }

  SetTheme(theme) {
    window.localStorage.setItem("theme", theme);
  }
}

export default ThemeLocalStorage;
